import { Box, Modal } from "@mui/material";

export const NoDayStartedModalPopup = (props) => {
    return (
        <>
            {props.sessionModal ? (
                <Modal
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    open={props.sessionModal}
                >
                    <Box
                        sx={{
                            backgroundColor: props.color === "dark" ? "#353a50" : "#fff",
                            color: props.color === "dark" ? "white" : "black",
                            position: props.isMobile ? "static" : "fixed",
                            top: "50%",
                            left: "30%",
                            maxWidth: props.isMobile ? "100%" : "30%",
                            maxHeight: "100%",
                            transform: props.isMobile ? "none" : "translate(50%, -50%)",
                            width: props.isMobile ? "100%" : "50%",
                            display: props.isMobile ? "flex" : "block",
                            borderRadius: "10px",
                            padding: "1.5rem",
                            flexDirection: "column",
                            justifyContent: "center",
                            ...(props.isMobile && { height: "100%" }),
                        }}
                    >
                        <h4>
                            Please start a session to proceed.{" "}
                            <b>We will be redirecting you to create session page</b>
                        </h4>
                    </Box>
                </Modal>
            ) : null}
        </>
    )
}